var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(-921 -935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(921 935)",
    fill: "#ea8b49"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-arrow-dropdown",
    "data-name": "Icon ionic-ios-arrow-dropdown",
    transform: "translate(917.846 947.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M11.031,15.478a3.612,3.612,0,0,0,0,5.09L28.873,38.354a3.594,3.594,0,0,0,4.959.112L51.414,20.941a3.592,3.592,0,1,0-5.071-5.09l-15.1,14.878L16.121,15.46A3.6,3.6,0,0,0,11.031,15.478Z",
    transform: "translate(10.913 18.23)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M3.375,42.154A38.779,38.779,0,1,0,42.154,3.375,38.773,38.773,0,0,0,3.375,42.154ZM65.347,18.961A32.8,32.8,0,1,1,18.961,65.347,32.8,32.8,0,1,1,65.347,18.961Z",
    transform: "translate(0 0)",
    fill: "#353535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.2679b8a93a2722bc00a0ec1442d38f8b.svg";
export { ForwardRef as ReactComponent };